<div class="mt-4xl">
  <h6 class="text-neutral-900 text-lg font-semibold mb-sm">
    {{ 'request_details_screen_requirement_tab_title' | transloco }}
  </h6>
  <p class="text-sm font-medium text-neutral-500">
    {{ 'request_details_screen_requirement_tab_description' | transloco }}
  </p>
</div>
<div class="mt-4xl requirement-container">
  @for (item of requirements(); track $index) {
    <div class="flex items-start mb-lg text-neutral-900 text-sm font-medium">
      <div class="flex items-center justify-center pt-sm">
        <svg
          width="6"
          height="6"
          viewBox="0 0 32 32"
          class="mx-md"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          preserveAspectRatio="xMidYMid meet">
          <circle cx="16" cy="16" r="16" fill="#000000"></circle>
        </svg>
      </div>

      <span>{{ item.value }}</span>
    </div>
  }
</div>
